var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHemburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.758558 0C0.339451 0 0 0.335869 0 0.74994C0 1.16402 0.339729 1.49988 0.758558 1.49988H13.6552C14.0743 1.49988 14.4138 1.16401 14.4138 0.74994C14.4138 0.335595 14.0741 0 13.6552 0H0.758558ZM0.758558 6.75006C0.339451 6.75006 0 7.08593 0 7.5C0 7.91407 0.339729 8.24994 0.758558 8.24994H21.2414C21.6606 8.24994 22 7.91407 22 7.5C22 7.08565 21.6603 6.75006 21.2414 6.75006H0.758558ZM0.758558 13.5001C0.339451 13.5001 0 13.836 0 14.2501C0 14.6641 0.339729 15 0.758558 15H13.6552C14.0743 15 14.4138 14.6641 14.4138 14.2501C14.4138 13.8357 14.0741 13.5001 13.6552 13.5001H0.758558Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHemburger);
export default __webpack_public_path__ + "static/media/hemburger.19a7ee1ab8c55297befe346106066bc2.svg";
export { ForwardRef as ReactComponent };